/**
 * This class represents the very basic behavior that a Result Tab on the Search Results should follow.
 * For example, every tab should have an active state, an url to refer and its HTML constructor.
 * If it is require to update some of the logic to perform some of those actions, you can override the function.
 */
export default class ResultTab {
  setIsActive(isActive) {
    this.isActive = isActive;
  }
  
  updateUrl(newUrl) {
    this.url = newUrl;
  }

  getHTML() {
    const activeClass = this.isActive ? 'nhs-n1-c-button__tab--light-active' : '';

    return `<a href='${this.url}' class='nhs-n1-c-button__tab nhs-n1-c-button__tab--light ${activeClass}' data-result-type='${this.resultType}'
            data-product-type='${this.productType}' data-qa=${this.qaAttribute}>${this.content}</a>`;
  }

  getNode() {
    return document.querySelector(`[data-result-type="${this.resultType}"][data-product-type="${this.productType}"]`);
  }
}